import { useEffect } from 'react'

import * as Sentry from '@sentry/react'
import { useSelector } from 'react-redux'

import { RootState } from '@/core/store'

export const SentryIdentify = () => {
	const { user, isAuthenticated } = useSelector(
		(state: RootState) => state.auth
	)
	const selectedAccount = useSelector(
		(state: RootState) => state.selectedAccount.selectedAccount
	)

	useEffect(() => {
		if (isAuthenticated && user) {
			// Set user context for Sentry
			const sentryUser = {
				id: String(user.id), // Convert to string for consistency
				email: user.email,
				username: user.getFullName(),
				// Add additional user properties
				role: user.role || 'unknown',
			}

			// Use global scope to ensure it's available everywhere
			Sentry.getCurrentScope().setUser(sentryUser)

			// Set custom context for account information
			Sentry.getCurrentScope().setContext('account', {
				id: user.accountId,
				name: user.account?.name,
				country: user.account?.country,
				mrr: user.account?.metadata?.total_mrr,
				segmentation: user.account?.metadata?.segmentation,
				playersCount: user.account?.playersCount,
				boxesCount: user.account?.availableBoxes,
			})

			// Set selected account context if available
			if (selectedAccount) {
				Sentry.getCurrentScope().setContext('selectedAccount', {
					id: selectedAccount.id,
					name: selectedAccount.name,
				})
			}

			// Set tags for filtering in Sentry dashboard
			Sentry.getCurrentScope().setTag('user_role', user.role || 'unknown')
			Sentry.getCurrentScope().setTag('account_id', String(user.accountId))
		} else {
			// Clear user context on logout
			Sentry.getCurrentScope().setUser(null)
			Sentry.getCurrentScope().setContext('account', null)
			Sentry.getCurrentScope().setContext('selectedAccount', null)
		}
	}, [isAuthenticated, user, selectedAccount])

	return null
}
